<template>
  <div>
    <el-upload
      ref="upload"
      class="avatar-uploader el-upload--text"
      :action="uploadUrl"
      :show-file-list="false"
      :on-success="handleVideoSuccess"
      :before-upload="beforeUploadVideo"
      :on-progress="uploadVideoProcess"
      :data="imageToken"
      :limit="1"
    >
      <video v-if="localUrl != '' && videoFlag == false" :src="localUrl" class="avatar" controls="controls">您的浏览器不支持视频播放</video>
      <i v-else-if="localUrl =='' && videoFlag == false" class="el-icon-plus avatar-uploader-icon" />
      <el-progress v-if="videoFlag == true" type="circle" :percentage="videoUploadPercent" style="margin-top:30px;" />
    </el-upload>
    <el-button v-if="localUrl" type="text" size="mini" @click="fnDeleteVideoUrl">删除视频</el-button>
    <P class="text">请保证视频格式正确，且不超过100M</P>
  </div>
</template>

<script>
import qiniuUpload from '@/assets/js/upload.js'
export default {
  name: 'UploadVideo',
  props: {
    url: String
  },
  data() {
    return {
      uploadUrl: qiniuUpload.qiniuUrl,
      videoFlag: false,
      videoUploadPercent: 0,
      localUrl: '',
      imageToken: {
        token: '',
        key: ''
      }
    }
  },
  watch: {
    url(val) {
      this.localUrl = val
    }
  },
  created: function() {
    this.localUrl = this.url
    this.fToken()
  },
  methods: {
    fToken() {
      this.$http.fToken().then(ret => {
        this.imageToken.token = ret.token
      })
    },
    beforeUploadVideo(file) {
      const fileType = file.type
      const current = new Date().getTime()
      const key = `video_${current}` // key为上传后文件名 必填
      const isLt20M = file.size / 1024 / 1024 < 100 // 算出文件大小
      this.fileSize = file.size // 存储文件大小
      if (!isLt20M) { // 这里我们限制文件大小为20M
        this.$message.error('最大只能上传100M!')
        this.$ref.upload.abort()
        return isLt20M
      }
      if (fileType !== 'video/mp4') { // 限制文件类型
        this.$ref.upload.abort()
        this.$message.error('只能上传MP4格式视频!')
        return false
      }
      this.imageToken.key = key + '.mp4'
    },
    fnDeleteVideoUrl() {
      this.localUrl = ''
      this.$emit('updateUrl', this.localUrl)
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = parseInt(file.percentage.toFixed(0))
    },
    handleVideoSuccess(res, file) {
      this.videoFlag = false
      this.videoUploadPercent = 0
      if (res.key) {
        this.localUrl = qiniuUpload.fileSpace + res.key
        this.$emit('updateUrl', this.localUrl)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-uploader-icon {
  border: 1px solid $color_blue;
  border-radius: 4px;
  font-size: 28px;
  color: $color_blue;
  width: 120px;
  height: 90px;
  line-height: 90px;
  text-align: center;
  overflow: hidden;
}
.avatar {
  border: 1px solid $color_blue;
  border-radius: 4px;
  width: 120px;
  height: 90px;
  display: block;
  overflow: hidden;
}
</style>
